module.exports = __webpack_public_path__ + "static/media/timer-red.18910d99.svg";